import { OrderedList } from '@tiptap/extension-ordered-list'
import { mergeAttributes } from '@tiptap/core'

export const EnhancedOrderedList = OrderedList.extend({
  name: 'orderedList',

  addAttributes() {
    return {
      ...this.parent?.(),
      listStyleType: {
        default: 'decimal',
        parseHTML: element => {
          // Parse list-style-type from style attribute
          const style = element.getAttribute('style')
          if (style) {
            const match = style.match(/list-style-type:\s*([^;]+)/)
            if (match) {
              return match[1].trim()
            }
          }
          return 'decimal'
        },
        renderHTML: attributes => {
          if (attributes.listStyleType && attributes.listStyleType !== 'decimal') {
            return {
              style: `list-style-type: ${attributes.listStyleType}`,
            }
          }
          return {}
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'ol',
        getAttrs: (element) => {
          const htmlElement = element as HTMLElement
          let listStyleType = 'decimal'

          // Parse list-style-type from style attribute
          const style = htmlElement.getAttribute('style')
          if (style) {
            const match = style.match(/list-style-type:\s*([^;]+)/)
            if (match) {
              listStyleType = match[1].trim()
            }
          }

          return { listStyleType }
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const dom = document.createElement('ol')

      Object.entries(mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          dom.setAttribute(key, String(value))
        }
      })

      const listStyleType = node.attrs.listStyleType || 'decimal'

      dom.style.listStyleType = listStyleType
      dom.style.listStylePosition = 'outside'
      dom.style.margin = '0'
      dom.style.padding = '0'
      dom.style.paddingInlineStart = '40px'

      return {
        dom,
        contentDOM: dom,
      }
    }
  },
})

export default EnhancedOrderedList
